module.exports = __webpack_public_path__ + "site-build/img/introduction_1.b2716e47.jpg";